"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _vuexModuleDecorators = require("vuex-module-decorators");
var _clients = require("@/api/clients");
var _index = _interopRequireDefault(require("@/components/HelpText/index.vue"));
var _router = _interopRequireDefault(require("@/router"));
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.clientData = Object.assign({}, _clients.defaultClientData);
    this.loading = false;
    this.rules = {
      name: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }, {
        min: 3,
        message: 'Minimum length should be 3',
        trigger: 'blur'
      }],
      gstNumber: {
        pattern: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
        message: 'Enter a valid GST number',
        trigger: 'blur'
      },
      panNumber: {
        pattern: /^([A-Z]){5}([0-9]){4}([A-Z]){1}?$/,
        message: 'Enter a valid PAN number',
        trigger: 'blur'
      }
    };
  }
  submitForm() {
    this.$refs.advanceFormRef.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        // this.$message.error("Failed to saved!");
        return false;
      }
    });
  }
  created() {
    this.clientData = this.formData;
  }
  emitFormData() {
    this.$emit('updated', this.clientData);
  }
  async saveForm() {
    this.loading = true;
    try {
      let response = {};
      if (!this.formData.gstNumber) {
        this.formData.gstNumber = null;
      }
      if (!this.formData.panNumber) {
        this.formData.panNumber = null;
      }
      if (this.isEdit) {
        response = await (0, _clients.updateClient)(this.clientData.id, this.clientData);
        this.$emit('reload', true);
      } else {
        response = await (0, _clients.createClient)(this.clientData);
        this.clientData = response;
        this.emitFormData();
        // to make other tabs available
        this.$emit('edited', true);
      }
      this.$notify({
        title: 'Success',
        message: 'Client saved',
        type: 'success',
        duration: 2000
      });
      this.loading = false;
      _router.default.push('/clients/list/');
    } catch (err) {
      this.$notify.error(err.toString());
    } finally {
      this.loading = false;
    }
  }
  resetForm() {
    this.$refs.advanceFormRef.resetFields();
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: {}
})], default_1.prototype, "formData", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], default_1.prototype, "isEdit", void 0);
(0, _tslib.__decorate)([_vuexModuleDecorators.Action], default_1.prototype, "saveForm", null);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'ClientAdvanceTab',
  components: {
    HelpText: _index.default
  }
})], default_1);
var _default = exports.default = default_1;